import type { SaveProjectBodyMetadata } from './saveProjectBodyMetadata';

export type SaveProjectBody = {
  /**
   * 모든 파일 목록 (프로젝트 ZIP + 미디어 파일들).
배열의 첫 번째 요소는 프로젝트 ZIP 파일이어야 합니다.
최소 2개 이상의 파일이 필요합니다 (ZIP 1개 + 미디어 최소 1개).
   * @minItems 2
   */
  files: Blob[];
  /** 프로젝트 메타데이터 (JSON 형식) */
  metadata: SaveProjectBodyMetadata;
};
